import { IAcc } from '../../../models/IProfile';
import styles from './sipAccountBlock.module.css';
import { SipAccountList } from './SipAccountList';

type Props = {
	accs: IAcc[];
	handleOpenAddNewSip: (item: IAcc) => void;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function SipAccountBlock({ accs, handleOpenAddNewSip }: Props) {
	return (
		<div className={styles.sipAccountBlock}>
			{accs.length > 0 && (
				<SipAccountList
					accs={accs}
					handleOpenAddNewSip={handleOpenAddNewSip} />)}
		</div>
	);
}
